import { createContext } from 'react';

import DefaultTextCopy from '../types/default-text-copy';

type WebinarRegistrationContextValue = {
  defaultCopyText: DefaultTextCopy
  mockRegistration: boolean
}

const WebinarRegistrationContext = createContext<WebinarRegistrationContextValue>(null!);

export default WebinarRegistrationContext;
